export default __webpack_public_path__ + "static/media/Roboto-VariableFont.79504ae1.woff2";